module.exports = __webpack_public_path__ + "static/media/Third-FlagLarge.cf0c1165.gif";